"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const translations_1 = require("./application/globals/translations");
if (!(0, translations_1.getLanguage)()) {
    (0, translations_1.setLanguage)('pl');
}
require("./application/globals/global-extensions");
const client_1 = __importStar(require("@rws-framework/client"));
const nest_interconnectors_1 = require("@rws-framework/nest-interconnectors");
const browser_router_1 = require("@rws-framework/browser-router");
const _initComponents_1 = __importDefault(require("./application/_initComponents"));
const backendImport_1 = require("./backendImport");
const routes_1 = __importDefault(require("./routes"));
require("./styles/main.scss");
const component_1 = require("./components/notifications/component");
require("./application/globals/directives");
const componentsSetup_1 = require("./application/componentsSetup");
const WSService_audio_1 = __importDefault(require("./services/WSService.audio"));
const IndexedDBService_1 = __importDefault(require("@rws-framework/client/src/services/IndexedDBService"));
const ServiceWorkerService_1 = __importDefault(require("@rws-framework/client/src/services/ServiceWorkerService"));
async function initializeApp() {
    const theClient = (0, client_1.RWSContainer)().get(client_1.default);
    const configService = (0, client_1.RWSContainer)().get(client_1.ConfigService);
    const indexedDBService = (0, client_1.RWSContainer)().get(IndexedDBService_1.default);
    const apiService = (0, client_1.RWSContainer)().get(client_1.ApiService);
    const wsService = (0, client_1.RWSContainer)().get(nest_interconnectors_1.WSService);
    const wsAudioService = (0, client_1.RWSContainer)().get(WSService_audio_1.default);
    const swService = (0, client_1.RWSContainer)().get(ServiceWorkerService_1.default);
    const partedMode = false;
    const lastSync = document.body.getAttribute('data-last-sync') || '0';
    if (localStorage.getItem('last_front_sync') !== lastSync) {
        const dbName = 'css-cache';
        indexedDB.deleteDatabase(dbName);
        localStorage.setItem('last_front_sync', lastSync);
    }
    (0, componentsSetup_1.setupStyles)();
    (0, componentsSetup_1.setupTables)();
    theClient.addPlugin(browser_router_1.RWSBrowserRouter);
    theClient.addPlugin(nest_interconnectors_1.RWSWebsocketsPlugin, {
        enabled: true,
        auto_notify: true
    });
    theClient.assignClientToBrowser();
    theClient.onInit(async () => {
        client_1.RWSPlugin.getPlugin(browser_router_1.RWSBrowserRouter).addRoutes(routes_1.default);
        (0, _initComponents_1.default)(partedMode);
    });
    if (localStorage.getItem('_jwt')) {
        theClient.apiService.setToken(localStorage.getItem('_jwt'));
        wsService.setToken(localStorage.getItem('_jwt'));
        wsAudioService.setToken(localStorage.getItem('_jwt'));
        wsAudioService.init();
    }
    theClient.setNotifier((message, logType) => {
        component_1.NotificationsArea.sendNotification({
            content: message,
            type: logType
        });
    });
    await swService.registerServiceWorker();
    swService.onMessage('log', (data) => {
        console.log(`[SW Log] ${data.message}`);
    });
    // Send persisted token to the service worker and wait for confirmation
    const persistedJwt = localStorage.getItem('_jwt');
    if (persistedJwt) {
        await swService.setToken(persistedJwt);
    }
    await theClient.start({
        backendRoutes: backendImport_1.backendRoutes,
        backendUrl: process.env.BACKEND_URL,
        wsUrl: process.env.WS_URL,
        hot: true,
        partedDirUrlPrefix: '/js',
        parted: partedMode
    });
}
initializeApp().catch(console.error);
